import { BackofficeUser } from 'src/types/backoffice-user';
import { axiosInstance, endpoints } from 'src/utils/axios';

interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  admin?: BackofficeUser;
}

interface LoginData {
  email: string;
  password: string;
}

export const authRepository = {
  async login(data: LoginData): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.backoffice.auth.login, data);

    if (!response.data) {
      throw new Error('Login failed');
    }

    return response.data;
  },

  async refreshAccessToken(refreshToken: string): Promise<string> {
    const response = await axiosInstance.post(endpoints.backoffice.auth.refresh, { refreshToken });

    if (!response.data?.accessToken) {
      throw new Error('Failed to refresh access token');
    }

    return response.data.accessToken;
  },

  async logout(refreshToken: string): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.backoffice.auth.logout, { refreshToken });

    if (!response.data) {
      throw new Error('Logout failed');
    }

    return response.data;
  },
};
